import type { SVGProps } from "react";
const SvgVerticalDragAndDrop = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2.083}
      d="M6.667 5h.005m-.005 5h.005m-.005 5h.005m6.656-10h.005m-.005 5h.005m-.005 5h.005"
    />
  </svg>
);
export default SvgVerticalDragAndDrop;
